import { render, staticRenderFns } from "./ProductRegistrationRegister.vue?vue&type=template&id=76583be8&"
import script from "./ProductRegistrationRegister.vue?vue&type=script&lang=js&"
export * from "./ProductRegistrationRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports